<template>
  <div>
    <el-row>
      <el-col :span="2"
        ><div style="font-weight: bold; font-size: 16px; padding-bottom: 6px">
          产品分类
        </div></el-col
      >
      <el-col :span="6"
        ><el-button type="primary" size="small" @click="handleAdd('', {})"
          ><i></i>添加一级分类</el-button
        ></el-col
      >
    </el-row>
    <el-tree
      :data="data"
      :props="defaultProps"
      :render-content="renderContent"
      :expand-on-click-node="false"
    ></el-tree>
    <el-dialog
      :title="subTitle"
      center
      :visible.sync="addSubVisible"
      width="38%"
      @closed="handleSubClose"
    >
      <el-form
        :model="addSubForm"
        label-width="100px"
        :rules="subRules"
        ref="addSubForm"
      >
        <el-form-item label="分类名称" prop="categoryName">
          <el-input
            placeholder="请输入分类名称"
            v-model="addSubForm.categoryName"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类前缀" prop="categoryPrefix">
          <el-input
            placeholder="请输入分类前缀"
            v-model="addSubForm.categoryPrefix"
            @input="handleInput"
          ></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="17">
            <el-form-item label="分类编号" prop="categoryCode">
              <el-input
                placeholder="请输入分类编号"
                v-model="addSubForm.categoryCode"
                type="number"
                :disabled="subTitle === '编辑分类'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="subTitle !== '编辑分类'"
            ><el-button type="primary" size="small" @click="handleCode"
              >选择编号</el-button
            ></el-col
          >
        </el-row>
        <el-form-item label="分类型号" prop="modelType">
          <el-input
            placeholder="请输入分类型号"
            :disabled="true"
            v-model="addSubForm.modelType"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类描述" prop="description">
          <el-input
            placeholder="请输入分类描述"
            v-model="addSubForm.description"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitSubForm('addSubForm')"
            >提交</el-button
          >
          <el-button @click="resetSubForm('addSubForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="删除提示"
      center
      :visible.sync="deleteVisible"
      width="30%"
      @closed="delClose"
    >
      是否确认删除当前分类：{{ editData && editData.label }}？
      删除后，当前分类下的产品转移至
      <el-form
        :model="delForm"
        ref="delForm"
        label-width="100px"
        :rules="delRules"
      >
        <el-form-item label="分类名称" prop="categoryName">
          <el-select-tree
            :options="selectData"
            placeholder="请选择"
            width="100%"
            :defaultData="defaultValue"
            :treeProps="treeProps"
            @handleNodeClick="selectDrop"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitDelForm('delForm')"
            >提交</el-button
          >
          <el-button @click="resetDelForm('delForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="编号列表"
      :visible.sync="openCode"
      @close="closeCodeDailog"
    >
      <el-row class="search-add" :gutter="10">
        <el-col :span="12">
          最小值：{{
            codeData && codeData.unusedCodes && codeData.unusedCodes[0]
          }}
        </el-col>
        <el-col :span="12"> 最大值：{{ codeData && codeData.maxCode }} </el-col>
      </el-row>
      <el-radio-group class="radio_group_column" v-model="radio">
        <el-radio v-for="item in codeData.fullCodes" :label="item" :key="item"
          ><span :class="{ used: isUsed(item) }">{{ item }}</span></el-radio
        >
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addRadio">选择</el-button>
        <el-button @click="closeCodeDailog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import elSelectTree from "../../../components/SelectTree.vue";
var attributes = {
  //定义数据属性名称
  id: "id",
  parentId: "parentId",
  name: "categoryName",
  rootId: 0,
};
// this.$store
export default {
  components: {
    elSelectTree,
  },
  data() {
    return {
      defaultValue: {},
      codeData: {},
      treeProps: {
        value: "id",
        children: "children",
        label: "label",
      },
      radio: "",
      code: "",
      openCode: false,
      selectedValue: "",
      addSubVisible: false,
      deleteVisible: false,
      editData: null,
      subTitle: "添加子类",
      addMainForm: {
        categoryName: "",
        parentId: 0,
        categoryName: "",
      },
      addSubForm: {
        categoryName: "",
        categoryPrefix: "",
        categoryCode: "",
        modelType: "",
        description: "",
      },
      delForm: {
        categoryName: "",
      },
      data: [],
      originData: [],
      selectData: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
      subRules: {
        categoryName: [{ required: true, message: "请输入", trigger: "blur" }],
        categoryPrefix: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        categoryCode: [{ required: true, message: "请输入", trigger: "blur" }],
        modelType: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      delRules: {
        categoryName: [{ required: true, message: "请选择", trigger: "blur" }],
      },
    };
  },
  watch: {
    addSubForm: {
      handler(val) {
        if (this.addSubForm.categoryPrefix && this.addSubForm.categoryCode) {
          this.addSubForm.modelType = `${this.addSubForm.categoryPrefix}${this.addSubForm.categoryCode}`;
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.getList();
  },
  methods: {
    isUsed(item) {
      return this.codeData.usedCodes.includes(item);
    },
    addRadio() {
      this.openCode = false;
      this.$set(this.addSubForm, "categoryCode", this.radio);
    },
    closeCodeDailog() {
      this.openCode = false;
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: 99999,
      };
      params.categoryCode = "";
      params.modelType = "";
      this.$http.post("/manage/category/page", params).then((results) => {
        const cloneData = JSON.parse(JSON.stringify(results["data"]["data"]["records"]));
        this.originData =[...cloneData];
        this.data = this.tree(cloneData, attributes);
        this.selectData = this.tree(cloneData, attributes);
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    selectDrop(val) {
      console.log("选中---->", val);
      this.delForm.categoryName = val.id;
    },
    renderContent(h, { node, data, store }) {
      return (
        <span
          mouseenter="handleMouseEnter(node)"
          mouseleave="handleMouseLeave(node)"
        >
          <span>{node.label}</span>
          <span v-show="node.show" style="margin-left: 20px;">
            <el-button
              type="text"
              size="mini"
              on-click={() => this.handleAdd(node, data)}
            >
              添加子类
            </el-button>
            <el-button
              type="text"
              size="mini"
              on-click={() => this.handleEdit(node, data)}
            >
              编辑
            </el-button>
            {data.parentId !== 0 && (
              <el-button
                type="text"
                size="mini"
                on-click={() => this.handleDelete(node, data)}
              >
                删除
              </el-button>
            )}
            <span style="padding-left: 6px">分类数字：{data.data.kindNumber}</span>
          </span>
        </span>
      );
    },
    handleMouseEnter(node, data) {
      this.$set(data, "show", true); // 使用Vue.set来确保响应性更新
    },
    handleMouseLeave(node, data) {
      this.$set(data, "show", false); // 使用Vue.set来确保响应性更新
    },
    handleAdd(node, data) {
      console.log("Add", node, data);
      const len = Object.keys(data);
      if (!len.length) {
        this.subTitle = "添加分类";
      } else {
        this.subTitle = "添加子类";
      }
      this.addSubVisible = true;
      this.addSubForm = {};
      this.editData = data;
      this.$http.post("/manage/code/getCodeDistribution").then((res) => {
        if (res.data.code === 0) {
          this.codeData = res.data.data;
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    handleEdit(node, data) {
      console.log(data, "handleEdit");this.editData = data;
      this.addSubVisible = true;
      this.addSubForm = data.data;
      this.subTitle = "编辑分类";
      // this.$http
      //   .post("/manage/category/getById ", { id: data.id })
      //   .then((res) => {
      //     if (res.data.code === 0) {
      //       this.editData = res.data.data;
      //       this.addSubForm = res.data.data;
      //     } else {
      //       this.$message({
      //         message: res.data.message,
      //         type: "error",
      //       });
      //     }
      //   });
    },
    handleDelete(node, data) {
      console.log(data, "data");
      if (confirm("确认要删除吗？")) {
        const params = {
          forceDelete: false,
          id: data.data.id,
        };
        this.$http.post("/manage/category/delete", params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getList();
            this.deleteVisible = false;
          } else {
            this.editData = data;
            this.deleteVisible = true;
            const filterValue = this.originData.filter(i => i.parentId !== data.id).filter(i => i.id !== data.id);
            this.selectData = this.tree(filterValue, attributes);
          }
        });
      }
    },

    handleInput(value) {
      // 只保留英文字母
      const filteredValue = value.replace(/[^a-zA-Z]/g, "");
      this.addSubForm.categoryPrefix = filteredValue;
    },
    handleSubClose() {
      this.addSubVisible = false;
    },
    handleCode() {
      this.openCode = true;
    },
    submitSubForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            parentId: (this.editData.data && this.editData.data.id) || 0,
            ...this.addSubForm,
          };
          this.$http.post("/manage/category/save", params).then((res) => {
            if (res.data.code === 0) {
              this.addSubVisible = false;
              this.getList();
              this.$refs[formName].resetFields();
              this.$message({
                message: "操作成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    submitDelForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            forceDelete: true,
            id: this.editData.data.id,
            targetCategoryId: this.delForm.categoryName,
          };
          this.$http.post("/manage/category/delete", params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              this.getList();
              this.deleteVisible = false;
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    resetSubForm(formName) {
      this.addSubVisible = false;
      this.$refs[formName].resetFields();
      this.addSubForm = {};
    },
    delClose() {
      this.deleteVisible = false;
    },
    resetDelForm(formName) {
      this.$refs[formName].resetFields();
      this.deleteVisible = false;
    },
    tree(data, attributes) {
      let resData = data;
      let tree = [];
      for (let i = 0; i < resData.length; i++) {
        if (resData[i][attributes.parentId] === attributes.rootId) {
          let obj = {
            parentId: resData[i][attributes.parentId],
            id: resData[i][attributes.id],
            label: resData[i][attributes.name],
            data: resData[i],
            children: [],
          };
          if (resData[i].categoryPrefix && resData[i].categoryCode) {
            obj.label = `${obj.label}${resData[i].categoryPrefix}${resData[i].categoryCode}`;
          }
          tree.push(obj);
          resData.splice(i, 1);
          i--;
        }
      }
      run(tree);

      function run(chiArr) {
        if (resData.length !== 0) {
          for (let i = 0; i < chiArr.length; i++) {
            for (let j = 0; j < resData.length; j++) {
              if (chiArr[i].id == resData[j][attributes.parentId]) {
                let obj = {
                  parentId: resData[j][attributes.parentId],
                  id: resData[j][attributes.id],
                  label: resData[j][attributes.name],
                  children: [],
                  data: resData[j],
                };
                if (resData[j].categoryPrefix && resData[j].categoryCode) {
                  obj.label = `${obj.label}${resData[j].categoryPrefix}${resData[j].categoryCode}`;
                }
                chiArr[i].children.push(obj);
                resData.splice(j, 1);
                j--;
              }
            }
            run(chiArr[i].children);
          }
        }
      }
      return tree;
    },
  },
};
</script>
<style scoped>
.used {
  color: red !important;
}
.radio_group_column {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  max-height: 300px;
  overflow-y: auto;
}
.radio_group_column label {
  margin-bottom: 10px;
}
</style>
